import { axiosLevelTech } from '@/services/axiosConfig';
import { useUserStore } from '@/store/userJWTStore';
import { initTokens } from './apiServiceCSRF';
import { watch } from 'vue';
import { useUserDataStore } from '@/store/userDataStore';

  async function login(email: string, password: string): Promise<any> {
    const userStore = useUserStore();
    try {
      const response = await axiosLevelTech.post('api/login', {
        email,
        password,
      }).then((response) => {
        console.log('response', response);
        if (response.data && response.data.token) {
          let token = response.data.token;
          userStore.setToken(token);
          initTokens();
        }
        return response;
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async function logout(): Promise<any> {
    const userStore = useUserStore();
    try {
      const response = await axiosLevelTech.post('api/logout').then((response) => {
        console.log('response', response);
        userStore.setToken('');
        initTokens();
        return response;
      });
    }
    catch (error) { return Promise.reject(error); }
  }

  async function forgotPassword(email: string): Promise<any> {
    try {
      const response = await axiosLevelTech.post('api/forgot-password', { email });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  export const authService = {
  login, logout, forgotPassword
};
